import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from '@mui/material';
import { useT } from '../../i18n';

/** One-time temp-password reveal shown after creating a developer/cluster login. */
export function CredentialsDialog({
  credits,
  onClose,
}: {
  credits: { email: string; password: string } | null;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog open={!!credits} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('plt.credTitle')}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ pt: 1 }}>
          <Typography variant="body2">{t('plt.credNote')}</Typography>
          <TextField label={t('common.email')} value={credits?.email ?? ''} InputProps={{ readOnly: true }} fullWidth />
          <TextField label={t('plt.credPassword')} value={credits?.password ?? ''} InputProps={{ readOnly: true }} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions><Button onClick={onClose} variant="contained">{t('common.done')}</Button></DialogActions>
    </Dialog>
  );
}
